import 'bootstrap';
import Isotope from 'isotope-layout';
import 'magnific-popup';

import {initMap} from './google-map';
import {initAccordions} from './accordions';

const $win = $(window);
const $doc = $(document);

const $map = $('.js-init-map');

// Nav trigger
$('#nav-trigger').on('click', function (event) {
	event.preventDefault();

	$(this).add($('.header')).toggleClass('active');

	$('body').toggleClass('disable-scroll');
});

// Bar Form Header
var $jsExpand = $('.js-expand');
var $jsClose = $('.btn--close-bar');

$jsExpand.on('click', function(event) {
	event.preventDefault();

	$(this).toggleClass('open');

	$jsClose.removeClass('open');

	// $('.bar__body').addClass('active');

	$('.bar__body').slideToggle();
});

$jsClose.on('click', function(event) {
	event.preventDefault();

	$(this).toggleClass('open');

	$jsExpand.removeClass('open');

	// $('.bar__body').removeClass('active');

	$('.bar__body').slideToggle();
});


// Nav Trigger Aside
$('#nav-trigger-aside').on('click', function (event) {
	event.preventDefault();

	$(this).add('.content, .sidebar').toggleClass('active');
});

// Nav Trigger Aside Simple
$('#nav-trigger-simple').on('click', function (event) {
	event.preventDefault();

	$(this).add('.sidebar-simple').toggleClass('active');
});

// Open header popups sign up and login
$('.js-popup-access').on('click', function (event) {
	event.preventDefault();
	const $this = $(this);
	const $target = $this.attr('href');

	$($target).addClass('visible').siblings().removeClass('visible');
});

//  Close header popups
$('.js-popup-access-close').on('click', function (event) {
	event.preventDefault();
	const $this = $(this);

	$this.closest('.header__popup').removeClass('visible');
});

// News isotope
const grid = document.querySelector('.isotope-grid');

if(grid){
	const $filters = $('.filters-container [data-filter]');
	const istp = new Isotope(grid, {
		percentPosition: true
	});

	$filters.on('click', function (event) {
		event.preventDefault();

		const $this = $(this);
		const filterValue = $this.data('filter');

		$this.parent().addClass('current').siblings().removeClass('current');

		istp.arrange({filter: filterValue});
	});
	
	// Load more news
	$('.ajax-load-more').on('click', function(event) {
		event.preventDefault();

		const $this = $(this);
		const url = $this.attr('href');
		const $targetContainer = $($this.data('container'));

		$.ajax({
			url: url,
			success: function(data) {
				let container = document.createElement('div');

				$(container).append(data);

				let $elements = $(container).find('.isotope-item');

				$targetContainer.append($elements);

				istp.appended( $elements );
				istp.layout();
			}
		});
	});
}

// Load more news
$('.ajax-load').on('click', function(event) {
	event.preventDefault();

	const $this = $(this);
	const url = $this.attr('href');
	const $targetContainer = $($this.data('container'));

	$.ajax({
		url: url,
		success: function(data) {
			$targetContainer.append(data);
		}
	})
});

// Intro tabs 
$('.intro .intro__nav a').on('click', function (event) {
	event.preventDefault();

	const $this = $(this);
	const target = $this.attr('href');

	$(target).add($this.parent()).addClass('current').siblings().removeClass('current');
});

// Init Accordions
var $accTrigger = $('.accordion .accordion__head');
var $accParent = $('.accordion .accordion__section');
var $accBody = $('.accordion .accordion__body');

initAccordions($accTrigger, $accParent, $accBody);

initAccordions($('.js-accordion-trigger'), $('.js-accordion-parent'), $('.js-accordion-body'));

const popup = '#popup-access'; 

$('.popup-youtube').magnificPopup({
	disableOn: 700,
	type: 'iframe',
	mainClass: 'mfp-fade',
	removalDelay: 160,
	preloader: false,

	fixedContentPos: false
});

$win.on('load', function () {
	// Init Google Map
	$map.each(function() {
		initMap($(this));
	});

	// Modal popups
	if ( $(popup).length ) {
		$.magnificPopup.open({
			items: {
				src: popup
			},
			type: 'inline',
			preloader: false,
			modal: true
		},0);

		$(document).on('click', '.popup-modal-dismiss', function (e) {
			e.preventDefault();
			$.magnificPopup.close();
		});
	}
});

// Trigger hover on mobile
$('.box').on('click', function () {});


// WEBPACK FOOTER //
// ../src/assets/js/main.js